"use client";
import React, { useContext } from "react";
import styles from "./StickyCTA.module.css";

import { roundSessionCount } from "../../../utils/roundSessionCount";
import Dollar from "../../icons/Dollar";
import Star from "../../icons/Star";
import Button from "../../atoms/Button/Button";
import { OnePageCheckoutContext } from "@/providers/OnePageCheckout.provider";

interface IStickyCTAProps {
  hourly_rate: number;
  duration: number;
  rating: number;
  number_of_sessions: number;
}

const StickyCTAComponent = ({
  duration,
  hourly_rate,
  rating,
  number_of_sessions,
}: IStickyCTAProps) => {
  const { toggleOpen } = useContext(OnePageCheckoutContext);

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <div className={styles.price}>
          <Dollar />
          <span>${duration === 30 ? hourly_rate / 2 : hourly_rate} - </span>
          <p> {duration === 30 ? "30 minute call" : "1 hour call"}</p>
        </div>
        {number_of_sessions > 5 && (
          <div className={styles.rating}>
            <Star />
            <span>{rating.toFixed(1)}</span>
            <p>({roundSessionCount(number_of_sessions)} sessions)</p>
          </div>
        )}
      </div>
      <Button onClick={() => toggleOpen && toggleOpen()}>View Times</Button>
    </div>
  );
};

export default StickyCTAComponent;
